export enum HeaderTable {
  titleForProductTable = 'Proizvod',
}

export enum HeaderColumns {
  productName = 'Naziv proizvoda',
}

export enum TableColumns {
  name = 'Naziv',
  price = 'Cena',
  description = 'Opis',
  edit = 'Izmena',
  delete = 'Brisanje',
}


export enum ModalForAddOrUpdateProduct {
  titleForAddProduct = 'Dodavanje novog proizvoda',
  titleForUpdateProduct = 'Izmena podataka o proizvodu',
  //productNameEmpty = 'Potrebno je uneti naziv proizvoda.',
  //productNamePlaceholder = 'Naziv',
  saveSuccessMessage = 'Novi proizvod je uspešno sačuvan.',
  updateSuccessMessage = 'Proizvoda je uspešno izmenjen.',
  deleteSuccessMessage = 'Selektovan proizvod je uspešno obrisan.',
}


export enum Placeholders {
  productName = 'Naziv',
  price = 'Cena',
  description = 'Opis',
  productCategory = 'Kategorija proizvoda*',
}


